import BaseModel from "../BaseModel";

export default class AddressType extends BaseModel{
    static entity = 'addressTypes';
    static fields(){
        return {
            id: this.attr(null),
            desc: this.attr(null),
            user_id: this.attr(null)
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at',]
    }
    static route(){
        return '/addresses/types'
    }
}
